import $ from "jquery";
import {
  loadFont,
  drawToothNumber,
  drawBox,
  drawLine,
  drawPoint,
} from "@/components/draw/draw.js";
import { max } from "@kitware/vtk.js/Common/Core/Math";

const angle90 = (90 * Math.PI) / 180;
const angle180 = (180 * Math.PI) / 180;

const dy = 3;
const dz = 5;

let numberFont = null;
let maxBox = null;
let maxCenter = null;
let mandBox = null;
let mandCenter = null;
let numbersVisible = false;
let numbersViewer = null;
let allTeeth = null;
let allItems = null;

async function initToothNumberOptions() {
  if (!numberFont) {
    numberFont = vueApp.defaultFont
      ? vueApp.defaultFont
      : await loadFont("fonts/helvetiker_regular.typeface.json");
    numbersViewer.controls.addEventListener("change", onCameraChangeForNumbers);
  }

  if (!maxCenter || !mandCenter) {
    maxBox = getTeethBox(true);
    maxCenter = new THREE.Vector3(
      maxBox.center.x,
      maxBox.max.y - maxBox.size.y / 3,
      maxBox.center.z
    );

    mandBox = getTeethBox(false);
    mandCenter = new THREE.Vector3(
      mandBox.center.x,
      mandBox.max.y - mandBox.size.y / 3,
      mandBox.center.z
    );
  }
}

function getTeethBox(isMaxilla) {
  var min = { x: 100000, y: 100000, z: 100000 };
  var max = { x: -10000, y: -100000, z: -100000 };
  var teethBox = { min, max };
  allItems.forEach(function (model) {
    // var mesh = numbersViewer.get_model_mesh(model.id);
    var mesh = model.mainMesh;
    if (
      mesh &&
      model.isTooth &&
      (isMaxilla == null || model.isMaxilla == isMaxilla)
    ) {
      var geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrix);
      var toothBox = geometry.boundingBox;
      if (toothBox.min.x < teethBox.min.x) {
        teethBox.min.x = toothBox.min.x;
      }
      if (toothBox.min.y < teethBox.min.y) {
        teethBox.min.y = toothBox.min.y;
      }
      if (toothBox.min.z < teethBox.min.z) {
        teethBox.min.z = toothBox.min.z;
      }
      if (toothBox.max.x > teethBox.max.x) {
        teethBox.max.x = toothBox.max.x;
      }
      if (toothBox.max.y > teethBox.max.y) {
        teethBox.max.y = toothBox.max.y;
      }
      if (toothBox.max.z > teethBox.max.z) {
        teethBox.max.z = toothBox.max.z;
      }
    }
  });
  teethBox = offsetBox(teethBox, 0, 0, 0, 0);
  //   drawBox(teethBox, null, numbersViewer);
  return teethBox;
}

async function drawTeethNumbers(ioViewer, allModels, isUpper) {
  numbersViewer = ioViewer;
  allItems = allModels;
  allTeeth = allItems.filter(
    (x) => x.isTooth && x.isUpper === isUpper && !x.isDeleted
  );

  await initToothNumberOptions();

  allTeeth.forEach((tooth) => {
    try {
      // let mesh = numbersViewer.get_model_mesh(tooth.id);
      var mesh = tooth.mainMesh;
      if (mesh && !mesh.textPoint) {
        let center = tooth.isMaxilla ? maxCenter : mandCenter;
        let box = tooth.defaultBox;

        let x = box.center.x;
        let y = box.center.y;
        let z = box.center.z;
        mesh.apexCenter = new THREE.Vector3(x, y, z);
        //   drawPoint(mesh.apexCenter, 0x00ff00, false, 0.4, numbersViewer);

        let distance = calculateDistance(mesh.apexCenter, center);
        let coef = (distance + dz * 2) / distance;
        let px = (x - center.x) * coef + center.x;
        let py = (y - center.y) * coef + center.y;
        let pz = (z - center.z) * coef + center.z;
        mesh.textPoint = new THREE.Vector3(px, py, pz);
        //   drawPoint(mesh.textPoint, 0x0000ff, false, 0.4, numbersViewer);
        //   drawLine(mesh.textPoint, mesh.apexCenter, 0xff0000, numbersViewer);

        mesh.apexEdge = mesh.apexCenter;
      }

      showToothNumber(tooth);
    } catch (error) {
      console.log("drawTeethNumbers ERROR", error, tooth);
    }
  });

  numbersVisible = true;
}

function showToothNumber(tooth) {
  if (tooth) {
    // let mesh = numbersViewer.get_model_mesh(tooth.id);
    var mesh = tooth.mainMesh;
    if (mesh && !mesh.numberGroup) {
      drawToothNumber(tooth, numberFont, false, numbersViewer, true);
    } else {
      numbersViewer.scene.add(mesh.numberGroup);
    }
    mesh.numberMesh.up = numbersViewer.camera.up;
    mesh.numberMesh.lookAt(numbersViewer.camera.position);
  }
}

function onCameraChangeForNumbers(controls) {
  if (numbersVisible && allTeeth) {
    allTeeth.forEach((tooth) => {
      // let mesh = numbersViewer.get_model_mesh(tooth.id);
      var mesh = tooth.mainMesh;
      if (mesh && mesh.numberMesh) {
        mesh.numberMesh.up = numbersViewer.camera.up;
        mesh.numberMesh.lookAt(numbersViewer.camera.position);
      }
    });
  }
}

function removeTeethNumbers() {
  if (numbersVisible && allTeeth) {
    allTeeth.forEach((item) => {
      // let mesh = numbersViewer.get_model_mesh(item.id);
      var mesh = item.mainMesh;
      if (mesh && mesh.numberGroup) {
        numbersViewer.scene.remove(mesh.numberGroup);
      }
    });
  }
  numbersVisible = false;
}

export { drawTeethNumbers, removeTeethNumbers, showToothNumber };
